export var isFetchBaseQueryError = function (error) {
    return typeof error === 'object' && error !== null && 'status' in error;
};
